module.exports = __webpack_public_path__ + "imgs/share-qzone@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/share-qzone@2x.png
// module id = 230
// module chunks = 93